import useAxiosInterceptor from '../interceptor';
import { apiPath } from './constants';

// Axios's default array serializer sends `activeDisciplines[]=PT`, but the backend's
// `@RequestParam List<Discipline> activeDisciplines` only binds repeated plain params
// (`activeDisciplines=PT`). Without this, the filter silently fails to bind and the
// backend falls back to "any discipline has an active cert".
const repeatArrayParamsSerializer = (params: Record<string, any>) => {
  const searchParams = new URLSearchParams();
  Object.entries(params ?? {}).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => searchParams.append(key, item));
    } else if (value !== undefined && value !== null) {
      searchParams.append(key, value);
    }
  });
  return searchParams.toString();
};

class PatientService {
  private axiosInstance;

  constructor() {
    // eslint-disable-next-line react-hooks/rules-of-hooks -- factory, not a React hook (matches npcLogService)
    this.axiosInstance = useAxiosInterceptor();
  }

  getPatientRecord = (payload: any) => {
    return this.axiosInstance.post(apiPath.patients, payload?.data, {
      params: payload?.params,
      paramsSerializer: repeatArrayParamsSerializer,
    });
  };

  getTherapistDisciplinePatient = (payload: any) => {
    return this.axiosInstance.get(`/provider/therapist-to-assign/${payload?.discipline}`);
  };
  getTreatmentTherapist = (payload: any) => {
    return this.axiosInstance.put(
      `/provider/${payload?.payload?.therapistId}/scheduling/${payload?.payload?.taskId}/treat-therapist`
    );
  };

  getPatientActiveInActiveCounts = (payload: any) => {
    return this.axiosInstance.get(`${apiPath.PATIENT}/count/${payload.facilityId}`);
  };

  getDownloadPatientCSVTemplate = () => {
    return this.axiosInstance.get(`${apiPath.PATIENT_CSV_TEMPLATE}/download-template`);
  };

  validateCSVTemplate = (payload: any) => {
    return this.axiosInstance.post(`${apiPath.PATIENT_CSV_TEMPLATE}/validate`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };

  uploadCSVTemplate = (payload: any) => {
    return this.axiosInstance.post(`${apiPath.PATIENT_CSV_TEMPLATE}/upload`, payload);
  };

  getPatientHistory = () => {
    return this.axiosInstance.get(apiPath.PATIENT_HISTORY);
  };

  getPatientExportTemplate = (payload: any) => {
    return this.axiosInstance.post(apiPath.PATIENT_EXPORT_CSV, payload);
  };

  getAllPatientWithoutPagination = () => {
    return this.axiosInstance.get(`${apiPath.GET_ALL_PATIENT}`);
  };

  // THIN-8229: NPC entry patient picker — all non-archived patients (active + inactive).
  getAllUnarchivedPatients = () => {
    return this.axiosInstance.get(`${apiPath.GET_ALL_UNARCHIVED_PATIENTS}`);
  };
}

const patientService = new PatientService();

Object.freeze(patientService);

export default patientService;
